import LoginModel from '../models/LoginModel';

export default class LoginCollection extends Backbone.Collection {
  constructor(options) {
    super(options);

    this.model = LoginModel;
  }

  url() {
    // hardcoded fake url at this point, real endpoints will be added
    // and environemnt specific api locations will be set up in the config.rb
    return `${appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV
      + appConstants.ApiPaths.API_VERSION_PATH}/departments/1/shifts`;
  }

  dispatchCallback(payload) {
    const { actionType } = payload;
    const { ActionTypes } = appConstants;

    switch (actionType) {
      case ActionTypes.POST_LOGIN:
        LoginStore.fetch({
          url:
            appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV
            + appConstants.ApiPaths.API_VERSION_PATH
            + appConstants.EndPoints.LOGIN_PATH,
          type: 'POST',
          dataType: 'json',
          actionType: appConstants.ActionTypes.POST_LOGIN,
          data: payload.postData,
          success: LoginStore.onSuccessfulLogin,
          error: LoginStore.onLoginError,
        });
        break;
      default:
        break;
    }
  }
}
